import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { CardNumberElement, CardCvcElement, CardExpiryElement } from '@stripe/react-stripe-js'

import TextField from '../../FormLegacy/FormFieldsV2/TextField'
import Loader from '../../Loader/Loader'
import { stripeElementOptions } from '../../CreditCardContent/helpers'

const CreditCardContent = ({
  isLoading,
  isLoadingBuildingCard,
  buildingCreditCard,
  cardOwnerFullName,
  verifyCardDataChanges,
  setBuildingCreditCard,
  setCardOwnerFullName,
}) => {
  const { t } = useTranslation(['payment'])
  if (isLoadingBuildingCard) return <Loader />
  return (
    <div className="card-elements">
      <div className="card-element-label">{t('payment:creditCard.cardNumberLabel')}</div>
      <div className={`card-element-wrapper ${isLoading ? 'is-loading-field' : ''}`}>
        <CardNumberElement
          id="card-number-element"
          options={{
            ...stripeElementOptions,
            placeholder: t('payment:creditCard.cardNumberPlaceholder', {
              last4: buildingCreditCard ? buildingCreditCard.last4 : '• • • •',
            }),
            disabled: !!buildingCreditCard,
          }}
          onChange={(event) => verifyCardDataChanges(event)}
        />
      </div>
      <div className="flex-row">
        <div className="short-card-element">
          <div className="card-element-label" style={{ top: '-3px' }}>
            {t('payment:creditCard.expirationDateLabel')}
          </div>
          <div className={`card-element-wrapper ${isLoading ? 'is-loading-field' : ''}`}>
            <CardExpiryElement
              id="card-expiry-element"
              options={{
                ...stripeElementOptions,
                placeholder: buildingCreditCard
                  ? buildingCreditCard.expDate
                  : t('payment:creditCard.expirationPlaceholder'),
                disabled: !!buildingCreditCard,
              }}
              onChange={(event) => verifyCardDataChanges(event)}
            />
          </div>
        </div>
        <div className="short-card-element">
          <div className="card-element-label" style={{ top: '-3px' }}>
            {t('payment:creditCard.cvvLabel')}
          </div>
          <div className={`card-element-wrapper ${isLoading ? 'is-loading-field' : ''}`}>
            <CardCvcElement
              id="card-cvc-element"
              options={{
                ...stripeElementOptions,
                placeholder: t('payment:creditCard.cvvPlaceholder'),
                disabled: !!buildingCreditCard,
              }}
              onChange={(event) => verifyCardDataChanges(event)}
            />
          </div>
        </div>
      </div>
      {buildingCreditCard ? (
        <div className="update-card-button" onClick={() => setBuildingCreditCard(null)}>
          {t('payment:creditCard.updateCardInfo')}
        </div>
      ) : (
        <React.Fragment>
          <div className="card-element-label">{t('payment:creditCard.cardHolderLabel')}</div>
          <div className={isLoading ? 'is-loading-field' : ''}>
            <TextField
              name={'cardholderName'}
              placeholder={t('payment:creditCard.namePlaceholder')}
              value={cardOwnerFullName}
              onChange={(event) => setCardOwnerFullName(event.target.value)}
            />
          </div>
          <div className="card-elements-info">{t('payment:creditCard.infoText')}</div>
        </React.Fragment>
      )}
    </div>
  )
}

CreditCardContent.propTypes = {
  isLoading: PropTypes.bool,
  isLoadingBuildingCard: PropTypes.bool,
  buildingCreditCard: PropTypes.object,
  cardOwnerFullName: PropTypes.string,
  verifyCardDataChanges: PropTypes.func,
  setBuildingCreditCard: PropTypes.func,
  setCardOwnerFullName: PropTypes.func,
}

export default CreditCardContent
